import { Injectable } from '@angular/core';

import { createEffect, Actions, ofType } from '@ngrx/effects';
import { combineLatest } from 'rxjs';
import { switchMap, map } from 'rxjs/operators';

import { EntitiesService } from '@apps/auth/domain/entities.service';
import { UsersMiscDomainService } from '@apps/auth/domain/users-misc-domain.service';
import { DashCounters } from '@apps/auth/domain/models/back/dash-counters';
import { Entity } from '@apps/auth/domain/models/back/entity';

import * as fromBackAuthStoreActions from './auth.actions';

@Injectable()
export class BackAuthEffects
{
    constructor (
        private actions: Actions,
        private entitiesService: EntitiesService,
        private usersService: UsersMiscDomainService
    )
    { }

    backAuthCountersRequested = createEffect(
        () =>
            this.actions
                .pipe(
                    ofType(fromBackAuthStoreActions.BackAuthCountersRequested),
                    switchMap(() =>
                        combineLatest([
                            this.entitiesService.getCounters(),
                            this.usersService.getCounters()
                        ])
                            .pipe(
                                map((dashCounters: DashCounters[]) =>
                                    fromBackAuthStoreActions.BackAuthCountersLoaded({
                                        entitiesCounters: dashCounters[0], usersCounters: dashCounters[1]
                                    })
                                )
                            )
                    )
                )
    );

    // // #region CRUD Users
    // backAuthUserIdentityUpdateRequested = createEffect(() =>
    //     this.actions
    //         .pipe(
    //             ofType(fromBackAuthStoreActions.BackAuthUserIdentityUpdateRequested),
    //             switchMap((action: any) =>
    //                 this.usersService.updateUser(action.user)
    //                     .pipe(
    //                         map((user: User) =>
    //                             fromBackAuthStoreActions.BackAuthUserIdentityUpdateSucceeded({
    //                                 external: action.external,
    //                                 user: user
    //                             })
    //                         ),
    //                         catchError(() =>
    //                             of(fromBackAuthStoreActions.BackAuthUserIdentityUpdateFailed())
    //                         )
    //                     )
    //             )
    //         )
    // );

    // backAuthUserIdentityUpdateSucceeded = createEffect(() =>
    //     this.actions
    //         .pipe(
    //             ofType(fromBackAuthStoreActions.BackAuthUserIdentityUpdateSucceeded),
    //             tap(() =>
    //             {
    //                 this.notificationService.notify([
    //                     'ADMIN.USERS.ACTIONS.EDITUSER.NOTF.TITLE',
    //                     'ADMIN.USERS.ACTIONS.EDITUSER.NOTF.MSGSUCCESS'
    //                 ],
    //                 NotfGravity.success,
    //                 NotifType.SNACKBAR
    //                 );
    //             }),
    //             map((params: { external: boolean, user: User }) =>
    //             {
    //                 const updateUser: Update<User> = {
    //                     id: params.user.id,
    //                     changes: {
    //                         ...params.user
    //                     }
    //                 };

    //                 return fromBackAuthStoreActions.BackAuthUserIdentityUpdated({
    //                     external: params.external,
    //                     user: updateUser
    //                 });
    //             })
    //         )
    // );

    // backAuthUserIdentityUpdateFailed = createEffect(() =>
    //     this.actions
    //         .pipe(
    //             ofType(fromBackAuthStoreActions.BackAuthUserIdentityUpdateFailed),
    //             tap(() =>
    //             {
    //                 this.notificationService.notify([
    //                     'ADMIN.USERS.EDITUSER.NOTF.TITLE',
    //                     'ADMIN.USERS.EDITUSER.NOTF.MSGFAILED'
    //                 ],
    //                 NotfGravity.danger,
    //                 NotifType.SNACKBAR
    //                 );
    //             })
    //         ),
    // { dispatch: false }
    // );

    backAuthUserEntityRequested = createEffect(() =>
        this.actions
            .pipe(
                ofType(fromBackAuthStoreActions.BackAuthUserEntityRequested),
                switchMap((params) =>
                    this.entitiesService.get(params.entityId)
                        .pipe(
                            map((entity: Entity) =>
                                fromBackAuthStoreActions.BackAuthUserEntityLoaded({ entity })
                            )
                        )
                )
            )
    );
}
